module.exports = __webpack_public_path__ + "media/images/500-error-image-0ea1bf3006686868c460201049e2c37b.svg";